<template>
  <div class="w-full overflow-auto p10" v-if="dataLegal">
    <div class="legal-document-header-wrapper">
      <div class="column50">Nama Dokumen</div>
      <div class="column15">Ketersediaan</div>
      <div class="column10">Tgl Efektif</div>
      <div class="column10">Tgl Berakhir</div>
      <div class="column15">Sisa Hari Efektif</div>
    </div>
    <div
      class="legal-document-wrapper"
      v-for="(list, index) in legalData"
      :key="index"
    >
      <div class="column50">
        <div>
          {{ list.desc ? list.desc : '-' }}
          <span v-if="list.required"
            >(
            <span :style="`color: ${list.required == 1 ? 'red' : 'blue'}`"
              >*</span
            >
            )</span
          >
        </div>
      </div>
      <div class="column15">
        <div :style="`color: ${list.lampiran ? 'black' : 'red'}`">
          {{ list.lampiran ? 'Yes' : 'No' }}
        </div>
      </div>
      <div class="column10">
        <div>
          {{ list.tanggal_efektif ? formatDate(list.tanggal_efektif) : '-' }}
        </div>
      </div>
      <div class="column10">
        <div>
          {{ list.tanggal_berakhir ? formatDate(list.tanggal_berakhir) : '-' }}
        </div>
      </div>
      <div :class="`column15 ${list.remainder < 0 ? `text-danger` : ''}`">
        <div>{{ reminder(list.reminder) }}</div>
      </div>
      <!-- <div class="ld-number-doc">
        <div v-if="list.desc !== 'NPWP (NOMOR POKOK WAJIB PAJAK)'">
          {{
            list.no_dokumen && list.no_dokumen != 'null' ? list.no_dokumen : '-'
          }}
        </div>
        <div v-else>
          <the-mask
            class="lv3-input-text"
            :mask="['##.###.###.#-###.###']"
            :value="
              list.no_dokumen && list.no_dokumen != 'null'
                ? list.no_dokumen
                : ''
            "
            style="border:none"
          />
        </div>
      </div>
      <div class="ld-file all-column">
        <div>{{ list.lampiran ? list.lampiran : '-' }}</div>
      </div>
      <div
        class="ld-download"
        @click="downloadDoc(list.lampiran)"
        v-if="list.lampiran && canDownload(list.type)"
      >
        <i class="fas fa-download"></i>
      </div>
      <div
        class="ld-edit"
        @click="showModal(list.id, list.desc)"
        v-if="canEdit(list.type)"
      >
        <i class="far fa-edit" v-if="editingStatus && editingUser"></i>
      </div> -->
    </div>

    <div
      class="legal-document-wrapper-mobile"
      v-for="(list, index) in legalData"
      :key="index"
    >
      <div>
        <div>
          {{ list.desc ? list.desc : '-' }}
          <span v-if="list.required"
            >(
            <span :style="`color: ${list.required == 1 ? 'red' : 'blue'}`"
              >*</span
            >
            )</span
          >
        </div>
      </div>
      <div>
        <div :style="`color: ${list.lampiran ? 'black' : 'red'}`">
          Ketersediaan: {{ list.lampiran ? 'Yes' : 'No' }}
        </div>
      </div>
      <div>
        Tgl efektif:
        <div>
          {{ list.tanggal_efektif ? formatDate(list.tanggal_efektif) : '-' }}
        </div>
      </div>
      <div>
        Tgl Berakhir:
        <div>
          {{ list.tanggal_berakhir ? formatDate(list.tanggal_berakhir) : '-' }}
        </div>
      </div>
      <div :class="`${list.remainder < 0 ? `text-danger` : ''}`">
        <div>Sisa Hari Efektif:{{ reminder(list.reminder) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  data() {
    return {
      showLegalDoc: true,
      legalData: [],
    }
  },
  computed: {
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.legaldoc_level_1.is_open',
        0
      )
    },
    editingUser() {
      return (
        this.$get(
          this.$store,
          'state.editingStore.legaldoc_level_1.user_id',
          ''
        ) == this.$get(this.$store, 'state.userid', 0)
      )
    },
    dataLegal() {
      let legal = this.$store.state.level1.dataLegal
      if (legal && legal.length > 0) {
        let legalWithoutKTP =
          this.$store.state.level1.dataLegal &&
          this.$store.state.level1.dataLegal.filter(
            i => i.legal_document_id != 35 && i.legal_document_id != 36
          )
        let ktpKomisaris =
          this.$store.state.level1.dataLegal &&
          this.$store.state.level1.dataLegal.filter(
            i => i.legal_document_id == 36
          )
        let ktpDirektur =
          this.$store.state.level1.dataLegal &&
          this.$store.state.level1.dataLegal.filter(
            i => i.legal_document_id == 35
          )

        let newKtpKomisaris = []
        if (ktpKomisaris && ktpKomisaris.length > 0) {
          for (let i in ktpKomisaris) {
            if (i == 0) {
              newKtpKomisaris.push(ktpKomisaris[i])
            } else {
              newKtpKomisaris.push({
                ...ktpKomisaris[i],
                desc: 'KTP KOMISARIS',
              })
            }
          }
        }

        let newKtpDirektur = []
        if (ktpDirektur && ktpDirektur.length > 0) {
          for (let i in ktpDirektur) {
            if (i == 0) {
              newKtpDirektur.push(ktpDirektur[i])
            } else {
              newKtpDirektur.push({
                ...ktpDirektur[i],
                desc: 'KTP DIREKTUR',
              })
            }
          }
        }

        this.legalData = [
          ...legalWithoutKTP,
          ...newKtpKomisaris,
          ...newKtpDirektur,
        ]

        return true
      }

      return false
    },
  },
  methods: {
    canDownload(type) {
      if (type == 1) {
        if (this.$get(this.$store, 'state.permissions.35.allow')) {
          return true
        }
        return false
      }
      if (type == 2 || type == 4 || type == 5) {
        if (this.$get(this.$store, 'state.permissions.36.allow')) {
          return true
        }
        return false
      }
      if (type == 3 || type == 0) {
        if (this.$get(this.$store, 'state.permissions.37.allow')) {
          return true
        }
        return false
      }

      return false
    },
    canEdit(type) {
      if (type == 1) {
        if (this.$get(this.$store, 'state.permissions.38.allow')) {
          return true
        }
        return false
      }
      if (type == 2 || type == 4 || type == 5) {
        if (this.$get(this.$store, 'state.permissions.39.allow')) {
          return true
        }
        return false
      }
      if (type == 3 || type == 0) {
        if (this.$get(this.$store, 'state.permissions.40.allow')) {
          return true
        }
        return false
      }

      return false
    },
    showModal(id, name) {
      this.$store.commit('modalStore/SHOW_LEGAL_DOC')
      this.$store.dispatch('editStore/getLegalDocById', { id, name })
    },
    reminder(value) {
      if (value) {
        if (value < 0) {
          return `${value} (Expired)`
        } else {
          return value
        }
      }

      return '-'
    },
    changeEditMode(id) {
      this.$store.dispatch('setEditMode', id)
    },
    viewDoc(link) {
      window.open(`${api}/file/${link}`)
    },
    downloadDoc(link) {
      if (link) {
        let linkUrl = `${api}/file/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
  },
}
</script>
